import React from 'react';
import styled from 'styled-components';


const Path = styled.path`
  fill: ${({ theme }) => theme.colors.secondary()};
`;

function HelpIcon(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26">
      <Path
        fillRule="nonzero"
        d="M20.255 1.059l-.667.667a12.559 12.559 0 00-12.709 0l-.634-.667c-.6-.6-1.6-.6-2.201 0L1.842 3.261c-.6.6-.6 1.6 0 2.201l.634.634a12.559 12.559 0 000 12.708l-.667.7c-.6.601-.6 1.602 0 2.202l2.202 2.202c.6.6 1.6.6 2.201 0l.634-.634a12.559 12.559 0 0012.708 0l.634.634c.6.6 1.601.6 2.201 0l2.202-2.202c.6-.6.6-1.6 0-2.201l-.567-.667a12.559 12.559 0 000-12.709l.634-.634c.6-.6.6-1.6 0-2.201l-2.202-2.202a1.54 1.54 0 00-2.201-.033zm-2.702 2.735l-1.635 1.601c-.133.134-.333.167-.533.134a7.279 7.279 0 00-4.303 0c-.2.066-.4 0-.534-.134L8.914 3.761a.507.507 0 01.167-.834 10.482 10.482 0 018.272 0c.367.167.467.6.2.867zm-.634 12.375c-2.001 2.035-5.337 2.035-7.338 0-2.001-2.035-2.035-5.337 0-7.338 2.035-2.001 5.337-2.035 7.371 0 2.035 2.035 2.002 5.337-.033 7.338zM4.544 8.197L6.18 9.832c.133.133.166.333.133.533a7.279 7.279 0 000 4.303c.067.2 0 .4-.133.534l-1.635 1.634a.507.507 0 01-.834-.167 10.482 10.482 0 010-8.272c.134-.367.567-.467.834-.2zm4.403 13.009l1.635-1.635c.133-.133.333-.166.533-.133a7.273 7.273 0 004.303 0c.2-.067.4 0 .534.133l1.634 1.635c.267.267.167.7-.167.834a10.482 10.482 0 01-8.272 0c-.367-.134-.467-.567-.2-.834zm13.009-4.403l-1.601-1.635c-.134-.133-.167-.333-.134-.533a7.279 7.279 0 000-4.303c-.066-.2 0-.4.134-.534l1.634-1.634a.507.507 0 01.834.167 10.482 10.482 0 010 8.272c-.167.367-.6.467-.867.2z"
      />
    </svg>
  );
}

export default HelpIcon;
